import { Module } from '@/interfaces/module';
import { ModuleResource, moduleResource } from '@/resources/module.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł modułów
 *
 * @export
 * @class ModuleModule
 * @extends {EntityModule<Module, ModuleResource>}
 */
export class ModuleModule extends EntityModule<Module, ModuleResource> {
  constructor() {
    super(moduleResource);
  }
}

export default new ModuleModule();
